interface CsvUploadLinkProps {
  onFile: (file: File) => void;
  label?: string;
  /** Hover text — say what the upload does with the rows, if it matters. */
  title?: string;
}

/**
 * The CSV entry point, wherever entries are being typed.
 *
 * Shared so the start state and the open form offer it identically — it is
 * another way to fill the same field, not a feature of one of them.
 */
export default function CsvUploadLink({
  onFile,
  label = "Upload CSV",
  title,
}: CsvUploadLinkProps) {
  return (
    <label
      title={title}
      className="inline-flex cursor-pointer items-center gap-1.5 text-xs text-squawk-blue transition-colors hover:text-squawk-blue/80"
    >
      <input
        type="file"
        accept=".csv"
        onChange={(e) => {
          if (e.target.files?.[0]) {
            onFile(e.target.files[0]);
            e.target.value = "";
          }
        }}
        className="sr-only"
      />
      {label}
    </label>
  );
}
